<script>
    export let id;
</script>

<section {id} class="active">
    <slot />
</section>
